import { Dialog } from "vant";

// 配置API接口地址
var root = "https://yitou.test";
if (window.location.host === "m.ahyc-house.com") {
  root = "https://www.ahyc-house.com";
}
if (window.location.host === "myitou.hzan.com.cn") {
  root = "https://yitou.hzan.com.cn";
}

// 引用axios
var axios = require("axios");
// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key];
    }
    if (toType(o[key]) === "string") {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === "object") {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === "array") {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}
/*
  接口处理函数
  这个函数每个项目都是不一样的，我现在调整的是适用于
  https://cnodejs.org/api/v1 的接口，如果是其他接口
  需要根据接口的参数进行调整。参考说明文档地址：
  https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
  主要是，不同的接口的成功标识和失败提示是不一致的。
  另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/

function apiAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params);
  }
  axios({
    method: method,
    headers: {
      Authorization: "Bearer " + window.localStorage.token,
    },
    url: url,
    data: method === "POST" || method === "PUT" ? params : null,
    params: method === "GET" || method === "DELETE" ? params : null,
    baseURL: root,
    withCredentials: false,
  })
    .then(function (res) {
      success(res.data);
    })
    .catch(function (err) {
      if (err.response) {
        if (err.response.status === 401) {
          Dialog.alert({
            title: "提示信息",
            message: "您的登录已过期，请重新登录！",
          }).then(() => {
            window.localStorage.token = "";
            window.location.href = "/";
          });
        } else if (err.response.status === 410) {
          failure(err.response);
        } else if (err.response.status === 500) {
          Dialog.alert({
            title: "提示信息",
            message: "非常抱歉，由于服务器出错，跳转到登录页重新刷新再登录",
          });
        } else {
          Dialog.alert({
            title: "提示信息",
            message: err.response.data.message,
          });
        }
        return;
      }
    });
}

// 返回在vue模板中的调用接口
export default {
  get: function (url, params, success, failure) {
    return apiAxios("GET", url, params, success, failure);
  },
  post: function (url, params, success, failure) {
    return apiAxios("POST", url, params, success, failure);
  },
  put: function (url, params, success, failure) {
    return apiAxios("PUT", url, params, success, failure);
  },
  delete: function (url, params, success, failure) {
    return apiAxios("DELETE", url, params, success, failure);
  },
};



// WEBPACK FOOTER //
// ./src/api/index.js